// src/data/blogData.js
export const blogPosts = [
  {
    id: '1',
    title: "Demystifying Golf: Making the Sport Accessible to Everyone",
    excerpt: "Learn how we're breaking down barriers and making golf more approachable for beginners and enthusiasts alike.",
    content: `
      <h2>Demystifying Golf: A New Approach</h2>
      <p>For decades, golf has been perceived as an exclusive sport, reserved for the elite. At Golf4International, we're challenging this notion by creating accessible pathways for everyone to enjoy this beautiful game.</p>
      
      <h3>Breaking Down Barriers</h3>
      <p>Our approach focuses on three key areas:</p>
      <ul>
        <li><strong>Affordable Access:</strong> Through our innovative membership models and pay-per-play options</li>
        <li><strong>Technology Integration:</strong> Using simulators to practice in any weather condition</li>
        <li><strong>Community Building:</strong> Creating welcoming spaces for golfers of all skill levels</li>
      </ul>
      
      <h3>The Future of Golf</h3>
      <p>By combining traditional golf values with modern technology and inclusive practices, we're shaping the future of the sport. Our digital platforms and mobile-first approach ensure that golf education and community are just a tap away.</p>
      
      <p>Join us in revolutionizing how the world experiences golf. Whether you're a complete beginner or a seasoned player, there's a place for you in our growing community.</p>
    `,
    imageUrl: "https://eu-assets.simpleview-europe.com/wiltshire2015/imageresizer/?image=%2Fdmsimgs%2FGolf_Pro-Am_Team_861105441.jpg&action=ProductDetail",
    date: "June 15, 2024",
    readTime: "4 min",
    category: "Industry Insights",
    author: {
      name: "Col Raja Somusundaram (Retd)",
      role: "Founder & CMD",
      image: "/images/raja.jpg"
    },
    tags: ["Accessibility", "Innovation", "Community", "Beginner Golf"],
    featured: true
  },
  {
    id: '2',
    title: "Technology in Modern Golf: How Simulators Are Changing the Game",
    excerpt: "Discover how advanced golf simulators are revolutionizing training and making golf practice more accessible.",
    content: `
      <h2>The Simulator Revolution</h2>
      <p>Golf simulators are no longer just for entertainment - they've become essential training tools that offer precise data analysis and year-round practice opportunities.</p>
      
      <h3>Key Benefits of Modern Simulators</h3>
      <ul>
        <li><strong>Precision Metrics:</strong> Track launch angle, spin rate, ball speed, and club path with millimeter accuracy</li>
        <li><strong>Weather Independence:</strong> Practice anytime, regardless of weather conditions</li>
        <li><strong>Course Variety:</strong> Play on virtual replicas of the world's best courses</li>
        <li><strong>Instant Feedback:</strong> Receive immediate data-driven insights to improve your game</li>
      </ul>
      
      <h3>Our Technology Edge</h3>
      <p>At Golf4International, we've invested in state-of-the-art simulator technology that combines:</p>
      <ul>
        <li>High-speed cameras for accurate ball tracking</li>
        <li>Advanced software for realistic course simulation</li>
        <li>AI-powered swing analysis</li>
        <li>Virtual coaching capabilities</li>
      </ul>
      
      <p>These technologies allow us to provide personalized training programs that adapt to each player's unique needs and progress.</p>
    `,
    imageUrl: "https://media.istockphoto.com/id/1479684366/photo/golf-player-playing-golf-indoors-on-golf-simulator.jpg?s=612x612&w=0&k=20&c=lwyTBwJda9afn41rqR55DtiZVPc_yKZvH676668hWVA=",
    date: "June 8, 2024",
    readTime: "5 min",
    category: "Technology",
    author: {
      name: "Technical Team",
      role: "Simulator Specialists",
      image: "/images/operator.jpg"
    },
    tags: ["Technology", "Simulators", "Training", "Data Analysis"],
    featured: true
  },
  {
    id: '3',
    title: "Nurturing Talent: Our Approach to Creating World-Class Golfers",
    excerpt: "Explore our systematic approach to identifying and developing golf talent from grassroots to professional levels.",
    content: `
      <h2>Building Champions Through Systematic Development</h2>
      <p>Our academy isn't just about teaching golf - it's about developing complete athletes through a holistic approach that combines technical training, physical conditioning, and mental preparation.</p>
      
      <h3>The Four Pillars of Our Training System</h3>
      
      <h4>1. Technical Excellence</h4>
      <p>We focus on building perfect fundamentals through:</p>
      <ul>
        <li>Biomechanical analysis</li>
        <li>Video swing analysis</li>
        <li>Custom club fitting</li>
        <li>Personalized coaching programs</li>
      </ul>
      
      <h4>2. Physical Conditioning</h4>
      <p>Golf-specific fitness programs designed to:</p>
      <ul>
        <li>Increase swing speed and power</li>
        <li>Improve flexibility and mobility</li>
        <li>Prevent injuries</li>
        <li>Enhance endurance</li>
      </ul>
      
      <h4>3. Mental Game Development</h4>
      <p>We work with sports psychologists to help players develop:</p>
      <ul>
        <li>Focus and concentration techniques</li>
        <li>Pre-shot routines</li>
        <li>Pressure management strategies</li>
        <li>Competition mindset</li>
      </ul>
      
      <h4>4. Tournament Preparation</h4>
      <p>Our players receive comprehensive support for competition, including:</p>
      <ul>
        <li>Course strategy sessions</li>
        <li>Equipment optimization</li>
        <li>Travel and logistics support</li>
        <li>Post-tournament analysis</li>
      </ul>
      
      <h3>Success Stories</h3>
      <p>Already, our system has produced several promising talents who are making their mark in national and international competitions. Our structured pathway ensures that talented players can progress from beginner levels to professional tours with consistent support at every stage.</p>
      
      <p>We believe that with the right system, support, and dedication, India can produce world-class golfers who can compete at the highest levels of the sport.</p>
    `,
    imageUrl: "https://images.unsplash.com/photo-1611374243147-44a702c2d44c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Z29sZiUyMHBsYXllcnxlbnwwfHwwfHx8MA%3D%3D",
    date: "May 28, 2024",
    readTime: "6 min",
    category: "Academy",
    author: {
      name: "Lt Col (Mrs) Arita Raja (Retd)",
      role: "Director",
      image: "/images/arita.jpg"
    },
    tags: ["Training", "Academy", "Talent Development", "Professional Golf"],
    featured: false
  },
  {
    id: '4',
    title: "The Financial Game: Managing Your Golf Business Successfully",
    excerpt: "Essential financial strategies and accounting practices for sustainable golf business operations.",
    content: `
      <h2>Financial Management in Golf Business</h2>
      <p>Running a successful golf facility requires more than just great courses and equipment - it demands sound financial management and strategic planning.</p>
      
      <h3>Key Financial Strategies</h3>
      <ul>
        <li><strong>Revenue Diversification:</strong> Multiple income streams from memberships, events, pro shop, and coaching</li>
        <li><strong>Cost Optimization:</strong> Efficient management of maintenance, staffing, and operational expenses</li>
        <li><strong>Investment Planning:</strong> Strategic investments in technology, facilities, and marketing</li>
        <li><strong>Risk Management:</strong> Protecting assets and ensuring business continuity</li>
      </ul>
      
      <h3>Accounting Best Practices</h3>
      <p>Proper accounting is crucial for any golf business:</p>
      <ul>
        <li>Accurate record-keeping of all transactions</li>
        <li>Regular financial reporting and analysis</li>
        <li>Compliance with tax regulations and financial standards</li>
        <li>Budget planning and variance analysis</li>
      </ul>
      
      <p>With proper financial management, golf businesses can thrive and contribute to the growth of the sport while ensuring sustainability and profitability.</p>
    `,
    imageUrl: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    date: "May 20, 2024",
    readTime: "5 min",
    category: "Business",
    author: {
      name: "Mr. Mahesh Ahirwar",
      role: "Accountant",
      image: "/images/mahesh.jpg"
    },
    tags: ["Finance", "Business", "Accounting", "Management"],
    featured: false
  },
  {
    id: '5',
    title: "Corporate Golf Events: Building Business Relationships on the Green",
    excerpt: "How golf events can enhance corporate networking, team building, and client relationships.",
    content: `
      <h2>The Power of Corporate Golf Events</h2>
      <p>Golf has long been recognized as an excellent platform for business networking and relationship building. Corporate golf events offer unique opportunities for meaningful connections in a relaxed environment.</p>
      
      <h3>Benefits of Corporate Golf Events</h3>
      <ul>
        <li><strong>Networking Opportunities:</strong> Extended time with clients and partners in a casual setting</li>
        <li><strong>Team Building:</strong> Fostering collaboration and camaraderie among employees</li>
        <li><strong>Client Entertainment:</strong> Creating memorable experiences for important clients</li>
        <li><strong>Brand Visibility:</strong> Showcasing your company in a premium environment</li>
      </ul>
      
      <h3>Planning Successful Corporate Events</h3>
      <p>Key elements for successful corporate golf events include:</p>
      <ul>
        <li>Professional event coordination and management</li>
        <li>Customized branding and sponsorship opportunities</li>
        <li>Quality catering and hospitality services</li>
        <li>Flexible formats for different group sizes and skill levels</li>
      </ul>
      
      <p>Whether it's a small client meeting or a large corporate tournament, golf events provide the perfect setting for business development and relationship building.</p>
    `,
    imageUrl: "https://images.unsplash.com/photo-1575361204480-aadea25e6e68?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    date: "May 15, 2024",
    readTime: "4 min",
    category: "Corporate",
    author: {
      name: "Events Team",
      role: "Corporate Relations",
      image: "/images/operator.jpg"
    },
    tags: ["Corporate", "Events", "Networking", "Business"],
    featured: false
  },
  {
    id: '6',
    title: "Sustainable Golf: Eco-Friendly Practices for Modern Courses",
    excerpt: "Implementing environmentally sustainable practices in golf course management and operations.",
    content: `
      <h2>Eco-Friendly Golf Course Management</h2>
      <p>As environmental awareness grows, golf courses are adopting sustainable practices to minimize their ecological footprint while maintaining premium playing conditions.</p>
      
      <h3>Sustainable Practices</h3>
      <ul>
        <li><strong>Water Conservation:</strong> Efficient irrigation systems and drought-resistant grasses</li>
        <li><strong>Chemical Reduction:</strong> Organic pest control and fertilizer management</li>
        <li><strong>Wildlife Habitat:</strong> Preserving natural areas and creating wildlife corridors</li>
        <li><strong>Energy Efficiency:</strong> Solar power and energy-efficient facilities</li>
      </ul>
      
      <h3>Environmental Benefits</h3>
      <p>Sustainable golf courses offer multiple environmental advantages:</p>
      <ul>
        <li>Reduced water consumption and chemical usage</li>
        <li>Enhanced biodiversity and habitat conservation</li>
        <li>Improved soil health and water quality</li>
        <li>Lower carbon footprint through energy efficiency</li>
      </ul>
      
      <p>By adopting sustainable practices, golf courses can become environmental stewards while providing excellent playing conditions for golfers.</p>
    `,
    imageUrl: "https://magazine.fortevillageresort.com/wp-content/uploads/2021/05/unsplash21039401-ufcDM0ApEBs-unsplash-scaled.jpg",
    date: "May 10, 2024",
    readTime: "6 min",
    category: "Sustainability",
    author: {
      name: "Operations Team",
      role: "Facility Management",
      image: "/images/operator.jpg"
    },
    tags: ["Sustainability", "Environment", "Green Golf", "Conservation"],
    featured: false
  }
];

// Helper function to get blog post by ID
export const getBlogPostById = (id) => {
  return blogPosts.find(post => post.id === parseInt(id));
};

// Helper function to get related posts
export const getRelatedPosts = (currentPostId, limit = 2) => {
  const currentPost = blogPosts.find(post => post.id === parseInt(currentPostId));
  if (!currentPost) return [];

  return blogPosts
    .filter(post =>
      post.id !== parseInt(currentPostId) &&
      (post.category === currentPost.category ||
        post.tags.some(tag => currentPost.tags.includes(tag)))
    )
    .slice(0, limit);
};

// Helper function to get featured posts
export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

// Helper function to get posts by category
export const getPostsByCategory = (category) => {
  return blogPosts.filter(post => post.category === category);
};

// Helper function to get all categories
export const getAllCategories = () => {
  const categories = blogPosts.map(post => post.category);
  return [...new Set(categories)]; // Remove duplicates
};

// Helper function to get all tags
export const getAllTags = () => {
  const allTags = blogPosts.flatMap(post => post.tags);
  return [...new Set(allTags)]; // Remove duplicates
};